module.exports = __webpack_public_path__ + "img/ilksms-gorsel-700x450.47c7c2e2.png";